export const mapCountryCoins = {
  "pt-BR": "BRL",
  "pt-PT": "EUR",
  "en-US": "USD",
};

export const mapCountryCurrency = {
  "pt-BR": "R$",
  "pt-PT": "€",
  "en-US": "$",
};
